import type { FeedbackMessages } from './en';

const ja: FeedbackMessages = {
  qualified: {
    title: 'ご協力いただきありがとうございました！',
    body1: 'このままブラウザウィンドウを閉じていただいて構いません。',
    body2: '近いうちに再びご参加いただけますことを楽しみにしております。',
    refCode: '参照コード: {code}',
  },
  quotaFull: {
    title: '本調査は終了いたしました',
    body1: '本調査にご興味をお持ちいただき、ありがとうございます。',
    body2: '誠に申し訳ございませんが、必要な回答数にすでに達しております。',
    body3: '今後の調査でまたお会いできることを楽しみにしております。',
    refCode: '参照コード: {code}',
  },
  terminated: {
    title: 'ご回答いただきありがとうございました！',
    body1: '今後の調査でまたお会いできることを楽しみにしております。それでは、良い一日をお過ごしください。',
    body2: 'このブラウザウィンドウを閉じてください。',
    refCode: '参照コード: {code}',
  },
  mismatch: {
    title: 'ご興味をお持ちいただきありがとうございます',
    body1: '誠に申し訳ございませんが、今回の調査の対象者には該当しませんでした。',
    body2: 'このページを閉じていただいて構いません。',
    code: 'コード: {code}',
  },
  error: {
    title: 'リクエストを処理できませんでした',
    linkProblemDetailed:
      'アクセスされたリンクに問題が発生しています。アドレスバーのリンクが、お送りしたものと一致しているかご確認のうえ、もう一度お試しください。',
    linkProblemGeneric: 'アクセスされたリンクに問題が発生しています。もう一度お試しください。',
    contactPerson:
      '問題が解決しない場合は、リンクをお送りした担当者にこの問題についてお知らせください。',
    errorCode: 'エラーコード: {code}',
  },
};

export default ja;
